import { render, staticRenderFns } from "./BillOfMaterialDetailUpload.vue?vue&type=template&id=5c5d6e59&"
import script from "./BillOfMaterialDetailUpload.vue?vue&type=script&lang=js&"
export * from "./BillOfMaterialDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports